import type { Novidade } from './tipos';

/** Fase 2, W12: Assinaturas e recorrência (Contratos e Reajustes no Comercial) e o MRR de verdade. */
export const novidadeContratos: Novidade = {
  id: '2026-10-05-contratos',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'assinaturas',
  permissao: 'assinaturas.ver',
  rota: '/comercial/assinaturas/contratos',
  textos: {
    pt: {
      titulo: 'Contratos e Reajustes no Comercial',
      resumo: 'O contrato fatura sozinho no Contas, a cada competência, e o reajuste por índice passa pela sua aprovação.',
      passos: [
        'Em Comercial, Contratos, crie o contrato com cliente, itens do catálogo de serviços, desconto e recorrência a cada N meses.',
        'A previsão de 12 meses fica no contrato; a fatura nasce no Contas no dia de geração, uma vez por competência.',
        'Um mês antes do aniversário, a aba Reajustes mostra o acumulado do índice com o valor atual e o novo. Aprovar só ajusta as cobranças futuras.',
        'O MRR no topo e no Início é mensalizado: anual divide por 12, pausado e encerrado saem.',
      ],
    },
    en: {
      titulo: 'Contracts and Adjustments in Sales',
      resumo: 'The contract bills by itself in Accounts every period, and index adjustments go through your approval.',
      passos: [
        'In Sales, Contracts, create the contract with customer, catalog service items, discount and recurrence every N months.',
        'The 12-month forecast stays in the contract; the invoice is created in Accounts on the generation day, once per period.',
        'One month before the anniversary, the Adjustments tab shows the accumulated index with the current and the new amount. Approving only adjusts future billings.',
        'The MRR at the top and on Home is monthly: yearly divides by 12, paused and ended contracts leave it.',
      ],
    },
    es: {
      titulo: 'Contratos y Reajustes en Comercial',
      resumo: 'El contrato factura solo en Cuentas en cada período, y el reajuste por índice pasa por tu aprobación.',
      passos: [
        'En Comercial, Contratos, crea el contrato con cliente, ítems del catálogo de servicios, descuento y recurrencia cada N meses.',
        'La previsión de 12 meses queda en el contrato; la factura nace en Cuentas el día de generación, una vez por período.',
        'Un mes antes del aniversario, la pestaña Reajustes muestra el acumulado del índice con el valor actual y el nuevo. Aprobar solo ajusta los cobros futuros.',
        'El MRR arriba y en Inicio es mensual: el anual divide por 12, pausados y finalizados salen.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-contratos/contratos.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
